/**
 * This is a recursive function that increament node count of id passed by 1 and recursively calls parent node to increment itself
 * Hence for every passed node, it will increment all its ancestor's children count by 1
 * @param  {} id
 * @param  {} locationsMapping
 * @param  {} subLocationsCountMap
 */
const incrementSubLocationsCount = (id, locationsMapping, subLocationsCountMap) => {
  // check if there is a map entry for this ID, else create a new map entry
  if (!subLocationsCountMap.has(id)) {
    subLocationsCountMap.set(id, 0);
  }
  subLocationsCountMap.set(id, subLocationsCountMap.get(id) + 1);
  const parentId = locationsMapping[id].parentId;
  if (typeof parentId === 'string') {
    incrementSubLocationsCount(parentId, locationsMapping, subLocationsCountMap);
  }
};

/**
 * This functions takes locationsMapping and locations array as arguments
 * It builds a map data structure where each value represents the count of all the descendants (sub-locations) of that node including itself.
 * @param  {} locationsMapping
 * @param  {} locations
 * @returns  {} ;}
 */
export const getSubLocationsCountMapHelper = (locationsMapping, locationsArray) => {
  const subLocationsCountMap = new Map();
  try {
    locationsArray?.forEach(element => {
      incrementSubLocationsCount(element.id, locationsMapping, subLocationsCountMap);
    });
  } catch (err) {
    console.error('Failed to create sublocations count map.', err.message);
  }
  return subLocationsCountMap;
};

export const subLocationTooltipStyle = {
  width: '280px',
  marginLeft: '25px'
};
